import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable } from '../../components/DataTable';
import usePaginationV2 from '../../util/usePaginationV2';
import IsKazaDurumEnum from '../../enum/IsKazaDurumEnum';
import { parseAndFormatDate } from '../../util/DateUtil';
import ModulTipi from '../../enum/ModulTipi';
import MasterTenantModulservice from '../../service/MasterServices/MasterTenantModulService';
import FilterOptionEnum from '../../enum/FilterOptionEnum';
import AuthenticationType from '../../enum/AuthenticationType';
import CheckBoxListInput from '../../ui/CheckBoxListInput';


const MasterTenantModulDialog = ({ open, onClose, selectedKey }) => {

    const { t } = useTranslation();

    const [tenantModul, setTenantModul] = useState([]);




    useEffect(async () => {
        // If selectedKey or open has changed, update the search data
        if (open && selectedKey) {
            const result = await MasterTenantModulservice.get({ tenantId: selectedKey });
            setTenantModul(result.resultObject);
        }

    }, [open, selectedKey]);

    const handleUncheckToggle = async (key) => {
        const result = await MasterTenantModulservice.remove({
            tenantId: selectedKey,
            modulTipi: key
        });
        console.log("handleUncheckToggle" + key);
    }

    const handleToggle = async (key) => {
        const result = await MasterTenantModulservice.create({
            tenantId: selectedKey,
            modulTipi: key
        });

        console.log("handleToggle" + result);
    }


    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={"xl"}
            scroll="paper"
        >
            <DialogTitle>
                {t('title.MasterTenantModul')}
            </DialogTitle>

            <DialogContent dividers={true}>
                <CheckBoxListInput
                    enumObject={ModulTipi}
                    checkedItems={tenantModul.map(r => r.modulTipi)}
                    handleToggle={handleToggle}
                    handleUncheckToggle={handleUncheckToggle}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">{t('button.close')}</Button>
            </DialogActions>
        </Dialog>
    );

};


export default MasterTenantModulDialog;

